import { jss } from 'react-jss'

const stylesProviderProps = { jss }

export default stylesProviderProps
